import { createActions } from 'redux-actions';

const {checkActiveProfile} = createActions(
    "CHECK_ACTIVE_PROFILE"
);

export { checkActiveProfile};
